import {
  GoalFilterDocument,
  GoalSortingMode,
  GroupByMode,
} from '@griply/types';

export type GoalListEntityUpdate = {
  goalSortingMode: GoalSortingMode;
  goalFilterDocument: GoalFilterDocument;
};

// StartDate fallback: an absent draft sort must never null-wipe the entity's sort.
export const getGoalListEntityUpdate = (
  draft: GoalFilterDocument,
): GoalListEntityUpdate => ({
  goalSortingMode: draft.sortingMode ?? GoalSortingMode.StartDate,
  goalFilterDocument: {
    groupByMode: draft.groupByMode ?? GroupByMode.None,
    filters: draft.filters ?? null,
    collapsedSections: draft.collapsedSections ?? null,
  },
});
